// extracted by mini-css-extract-plugin
export var body = "_ky-0";
export var sectionHeader = "_ky-4";
export var shortcutColumns = "_ky-2";
export var shortcutList = "_ky-1";
export var shortcutSection = "_ky-3";